import { IAmplitudeContextValue } from './types'

export const defaultValue: IAmplitudeContextValue = {
    trackAmplitudeEvent: () => ({
        promise: Promise.resolve({ success: true }),
    }),
}
